export default {
  'profile.updatesuccess': 'Ihr Profil wurde erfolgreich aktualisiert',
  'profile.insertsuccess': 'Ihr Profil wurde erfolgreich erstellt',
  'profile.profile': 'Profil',
  'profile.search': 'suchen',
  'profile.oldpassword': 'altes Password',
  'profile.newpassword': 'neues Password',
  'profile.logo': 'Logo',
  'profile.workinghours': 'Arbeitsstunden',
  'profile.nationalcardfile': 'Nationale Kartei',
  'profile.addfile': 'Datei hinzufügen',
  'profile.editinformation': 'Profilinformationen bearbeiten',
  'profile.email': 'E-Mail',
  'profile.weekdays': 'Wochentage',
  'profile.close': 'Abschließen',
  'profile.savechanges': 'Änderungen speichern',
  'profile.deleteconfirmation': 'Möchten Sie wirklich löschen?',
  'profile.rolename': 'Rollenname',
  'profile.register': 'Anmeldung',
  'profile.delete': 'löschen',
  'profile.addemployee': 'Neuen Mitarbeiter hinzufügen',
  'profile.deleteemployee': 'Mitarbeiter löschen',
  'profile.cancel': 'Abbrechen',
  'profile.number': 'Nummer',
  'profile.fromtime': 'Von ....',
  'profile.totime': 'Bis.....',
  'profile.setworkinghours': 'Arbeitsstunden einstellen',
  'profile.phone': 'Telefon',
  'profile.selectyear': 'Wählen Sie das Jahr',
  'profile.selectmonth': 'Wählen Sie den Monat',
  'profile.selectday': 'Wählen Sie den Tag',
  'profile.address': 'AAnschrift / Adresse',
  'profile.companyname': 'Betriebsname',
  'profile.englishcompanyname': 'englische Betriebsname',
  'profile.persiancompanyname': 'persische Betriebsname',
  'profile.removeaddress': 'Adresse entfernen',
  'profile.moreaddress': 'Adresse hinzufügen',
  'profile.removephone': 'Telefon entfernen',
  'profile.addphone': 'Telefon hinzufügen',
  'profile.registercode': 'Code registrieren',
  'profile.managername': 'Name des Managers / Agents(Erforderlich)',
  'profile.businessmanagername': 'Name des Managers / Agents',
  'profile.type': 'Geschäftsart(Erforderlich)',
  'profile.businesstype': 'Geschäftsart',
  'profile.licensefile': 'Lizenzdatei',
  'profile.updatepassword':
    'Bitte aktualisieren Sie Ihr Passwort, um fortzufahren',
  'profile.editprofile': 'Geschäftsprofil bearbeiten',
  'profile.individualprofile': 'Profil bearbeiten',
  'profile.inviteemployee': 'Mitarbeiter einladen',
  'profile.change': 'ändern',
  'profile.firstname': 'Vornamee',
  'profile.lastname': 'Nachname',
  'profile.mobile': 'Handynummer',
  'profile.nationalcode': 'Ausweisnummer',
  'profile.password': 'Password',
  'profile.username': 'Benutzername',
  'profile.username/email': 'Benutzername / E-Mail',
  'profile.gender': 'Geschlecht',
  'profile.birthdate': 'Geburtsdatum',
  'profile.businessbooking': 'Meine Bestellungen',
  'profile.selectavatar': 'Wählen Sie Avatar',
  'profile.adminitstrator': 'Administrator/in',
  'profile.book/reserve': 'Meine Bestellungen',
  'profile.changepassword': 'Passwort ändern',
  'profile.editpersonalprofile': 'Profil bearbeiten',
  'profile.onlinesupport': 'Online Unterstützung',
  'profile.employee': 'Mitarbeiter',
  'profile.addprofile': 'Neues Geschäftsprofil hinzufügen',
  'profile.addbusiness': 'Firma / Arbeit hinzufügen',
  'profile.encompanyname': 'englischer Firmenname(erforderlich)',
  'profile.facompanyname': 'lokaler Firmenname(erforderlich)',
  'profile.myProfile': 'mein Profil',
  'profile.textProfile':
    'In diesem Abschnitt können Sie Ihre Profilinformationen einsehen',

  'profile.airlinequota': 'Flugkontingent',
  'profile.signiture': 'Unterschriftenprofil',
  'profile.addsigniture': 'Kontingent erfolgreich hinzugefügt',
  'profile.signout': 'Abmelden',
  'profile.signituresave': 'Die Unterschrift wurde erfolgreich gespeichert',
  'profile.quotaadd': 'Kontingent hinzufügen',
  'profile.signitureerror': 'Bitte versuchen Sie es erneut',
  'profile.profiletype': 'Wählen Sie den Profiltyp',
  'profile.profilsend':
    'Das Profil wurde zur Überprüfung gesendet. Die Ergebnisse werden in Kürze bekannt gegeben',
  'profile.suspend': 'unterbrechen',
  'profile.nationalid': 'Ausweisnummer(Erforderlich)',
  'profile.businessnationalid': 'Ausweisnummer',
  'profile.activitycode': 'Aktivitätscode(Erforderlich)',
  'profile.businessactivitycode': 'Aktivitätscode',
  'profile.economiccode': 'Wirtschaftsgesetzbuch(Erforderlich)',
  'profile.businesseconomiccode': 'Wirtschaftsgesetzbuch',
  'profile.choosegateway': 'Wählen Sie Gateway',
  'profile.testconnection': 'Verbindung testen',
  'profile.savesigniture': 'Speichern Sie die Unterschrift',
  'profile.signitureping': 'Gateway pingte erfolgreich',
  'profile.country': 'Land',
  'profile.city': 'Stadt',
  'profile.role': 'Rolle',
  'profile.whoareyou': 'Wer bist du',
  'profile.license': 'Lizenz',
  'profile.licenses': 'Lizenzen',
  'profile.addlicense': 'Lizenz hinzufügen',
  'profile.viewlicense': 'Lizenzen anzeigen',
  'profile.removelicense': 'Lizenz entfernen',
  'profile.licensetype': 'Typ',
  'profile.upload': 'Hochladen',
  'profile.completeprofilepoint':
    'Um einen Punkt zu verdienen, vervollständigen Sie bitte Ihr Profil',
  'profile.licenseno': 'Lizenz Nr',
  'profile.addresswithoutindex': 'Anschrift /Adresse',
  'profile.phonewithoutindex': 'Telefon',
  'profile.underprocess': 'in Bearbeitung',
  'profile.fullname': 'voller Nam',
  'profile.airlinemarkup': 'Preiserhöhung von Fluggesellschaft',
  'profile.airlinename': 'Name der Fluggesellschaft',
  'profile.airlinetype': 'Typ der Fluggesellschaft',
  'profile.quota': 'Quote',
  'profile.markup': 'Preiserhöhung',
  'profile.savequota': 'Quote speichern',
  'profile.currency': 'Währung',
  'profile.passportNumber': 'Passnummer',
  'profile.userPointType': 'Benutzername',
  'profile.point': 'Punkte',
  'profile.savepoint': 'Punkt speichern',
  'profile.userpoint': 'Benutzerpunkt',
  'profile.subject': 'Thema',
  'profile.date': 'Datum zuweisen',
  'profile.totaluserpoint': 'Gesamtbenutzerpunkt',
  'profile.viewdetails': 'Details anzeigen',
  'profile.provider': 'Anbieter',
  'profile.b2brequest': 'Dienstanfrage',
  'profile.language': 'Sprache',
  'profile.department': 'Abteilung',
  'profile.adddetail': 'Weitere Details hinzufügen (wahlfrei)',
  'profile.identityno': 'Identität Nr',
  'profile.gateway': 'Gateway',
  'profile.hi': 'Hallo!',
  'profile.status': 'Status',
  'profile.approve': 'bestätigen',
  'profile.dissapprove': 'nicht bestätigen',
  'profile.pending': 'Ausstehend',
  'profile.notexitstuser': 'Dieser Benutzername existiert nicht',
  'profile.selectrole': 'Bitte Abteilung und Rolle auswählen',
  'profile.invitesuccessfully': 'Einladung erfolgreich gesendet',
  'profile.description': 'Beschreibung',
  'profile.filldescription': 'Bitte geben Sie eine Beschreibung ein',
  'profile.dashboard': 'Dashboard',
  'profile.mydashboard': 'Mein Dashboard',
  'profile.saleaccounting': 'Verkaufsbericht',
  'profile.profileaccounts': 'Kontenverwaltung',
  'profile.commissionmanagement': 'Kommission / Punkteverwaltung',
  'profile.uploadlogo': 'Laden Sie Ihr Firmenlogo hoch',
  'profile.uploadlicense': 'Laden Sie Ihre Lizenz hoch',
  'profile.deleteprofile': 'Profil löschen',
  'profile.airlineCommission': 'Airline-Kommission',
  'profile.licensepic': 'Lizenz Bild',
  'profile.errordelete': 'Es ist nicht möglich, diesen Datensatz zu löschen',
  'profile.editverification': 'Sind Sie sicher, dieses Profil zu löschen',
  'profile.reference': 'Ausstellende Behörde',
  'profile.logotitle':
    'Klicken Sie auf die Option unten, um das Firmenlogo zu bearbeiten',
  'profile.invitedepartment':
    'Sehr geehrter Benutzer, Sie wurden zum eingeladen ',
  'profile.inviteprofile': ' Abteilung in ',
  'profile.inviterole': ' Geschäftsprofil mit der Position von ',
  'profile.invite': '.Wenn Sie möchten, bestätigen Sie bitte die Einladung.',
  'profile.countercommission': 'Gegenkommission',
  'profile.ownercommission': 'Eigentümerkommission',
  'profile.bankaccounttype': 'Bankkontotyp',
  'profile.active': 'Aktiv',
  'profile.disactive': 'Deaktivieren',
  'profile.Individual': 'Individuell',
  'profile.bussiness': 'Unternehmen',
  'profile.postalcode': 'Postleitzahl',
  'profile.fax': 'Fax',
  'profile.accountingcode': 'Buchungscode',
  'profile.deletecustomer': 'Kunden löschen',
  'profile.insertcustomer': 'Kunden einfügen',
  'profile.updatecustomer': 'Kunden aktualisieren',
  'profile.both': 'beide',
  'profile.reload': 'Ricaricare',
  'profile.reloadfilter': 'Filter neu laden',
  'profile.isbusiness': 'Ist Geschäft',
  'profile.isactive': 'Ist aktiv',
  'profile.name': 'Name',
  'profile.registerdate': 'Registrierungsdatum',
  'profile.chargewallet': 'Laden Sie Ihre Brieftasche auf',
  'profile.currentcredit': 'Aktuelle Gutschrift',
  'profile.amount': 'Ladungsmenge',
  'profile.chargecreditmessgae':
    'Laden Sie Ihre Brieftasche auf, um den Kauf einfacher und sicherer zu machen.',
  'profile.credit': 'Anerkennung :',
  'profile.paymentdate': 'Zahlungsdatum',
  'profile.gotowalletpage': 'Zurück zum Aufladen der Brieftasche',
  'profile.notfound': 'Keine Aufzeichnungen gefunden',
  'profile.message': 'Botschaft',
  'profile.mypoint': 'Mein Punkt',
  'profile.pointtransaction': 'Punktetransaktion',
  'profile.buypoints': 'Punkt kaufen',
  'profile.wallet': 'Brieftasche',
  'profile.chooseRole': 'Wähle eine Rolle',
  'profile.commission': 'Kommission',
  'profile.addQuota': 'Kontingent hinzufügen',
  'profile.newQuota': 'Neues Kontingent',
  'profile.mycredit': 'Mein Kredit',
  'profile.departmentmanagement': 'Abteilungsleitung',
  'profile.customerphrase': 'Vollständiger Name / Buchungscode',
  'profile.enterusername': 'Geben Sie den gewünschten Benutzernamen ein',
  'profile.menucredit': 'Anerkennung :',
  'profile.personalprofile': 'Individuelles Profil',
  'profile.employeesearch': 'Suche nach Vorname, Nachname und Handy',
  'profile.gotowalletpage': 'Zurück zum Aufladen der Brieftaschenseite',
  'profile.documentdescription': 'Dokumentbeschreibung',
  'profile.documentnumber': 'Dokumentnummer',
  'profile.registertime': 'Zeit registrieren',
  'profile.price': 'Preis',
  'profile.errorsecondpassword':
    'Das zweite Passwort und die Wiederholung des zweiten Passworts sind nicht dasselbe',
  'profile.successsecondpassword':
    'Das zweite Passwort wurde erfolgreich gespeichert',
  'profile.insertinformation': 'Informationen einfügen',
  'profile.businessprofile': 'Unternehmensprofil',
  'profile.creditmanagement': 'Kreditmanagement',
  'profile.affiliateMarketing': 'Affiliate',
  'profile.account': 'Konto',
  'profile.individual': 'Individuell',
  'profile.business': 'Unternehmen',
  'profile.myfriends': 'Meine Freunde',
  'profile.viewCreditsAndWallets': 'Guthaben und Geldbörsen ansehen',
  'profile.employeeManagement': 'Mitarbeiterführung',
  'profile.customerManagement': 'Kundenverwaltung',
  'profile.financialmanagement': 'Finanzverwaltung',
  'profile.messagedate': 'Nachricht Datum',
  'profile.startMessagedate': 'Startdatum der Nachricht',
  'profile.endMessagedate': 'Ende der Nachricht',
  'profile.pointsremain': 'Punkte verbleiben',
  'profile.messagedescription': 'Nachrichtenbeschreibung',
  'profile.upgradeYourPlan': 'Aktualisieren Sie Ihren Plan',
  'profile.planCustomer': 'Plankunde',
  'profile.walletremain': 'Brieftasche bleiben',
  'profile.walletbalance': 'Wallet-Guthaben',
  'profile.chargeamount': 'Ladungsmenge(IRR)',
  'profile.bankreceipt': 'Bankbeleg',
  'profile.online': 'Online',
  'profile.increasebalance': 'Guthaben erhöhen',
  'profile.selectedbills': 'Ausgewählte Rechnungen',
  'profile.paymentbills': 'Zahlungsrechnungen',
  'profile.': 'Kundenverwaltung',
  'profile.employeeList': 'Mitarbeiterliste',
  'profile.addEmployee': 'Mitarbeiter hinzufügen',
  'profile.sendingInvitation': 'Einladung senden',
  'profile.employee': 'Mitarbeiter',
  'profile.call': 'Anruf',
  'profile.message': 'Nachricht',
  'profile.increaseOrEditCredentials':
    'Anmeldeinformationen erhöhen oder bearbeiten',
  'profile.sendToGroup': 'An Gruppe senden',
  'profile.theDesiredRole': 'Die gewünschte Rolle',
  'profile.addDepartment': 'Abteilung hinzufügen',
  'profile.employeeRole': 'Mitarbeiterrolle',
  'profile.moreDetails': 'Weitere Details',
  'profile.mehdiAbdollahiMehr': 'Mehdi Abdollahi Mehr',
  'profile.hiMessage': 'Hi, wo bist du?',
  'profile.inWork': 'Inwork',
  'profile.addNew': 'Neu hinzufügen',
  'profile.reminding': 'Erinnerung',
  'profile.participate': 'Teilnehmen',
  'profile.sportsInteractive': 'Sports Interactive',
  'profile.team': 'Team',
  'profile.tasks': 'Aufgaben',
  'profile.chooseAnArtist': 'wähle einen Künstler',
  'profile.prepareForACallWithAClient':
    'Bereiten Sie einen Anruf mit einem Client vor',
  'profile.prepareAEKtemplateForTheClient':
    'Bereiten Sie eine EK-Vorlage für den Kunden vor',
  'profile.prepareDetiledBrief':
    'Bereite einen detaillierten Brief für Entwickler und 04:12-Designer vor',
  'profile.more': 'Mehr',
  'profile.position': 'Position',
  'profile.employeeInformation': 'Mitarbeiterinformationen',
  'profile.employeeRegistrationDate': 'Datum der Mitarbeiterregistrierung',
  'profile.creditAmount': 'Kreditbetrag',
  'profile.theCeilingOfEachPurchase': 'Obergrenze jedes Kaufs',
  'profile.validityDuration': 'Gültigkeitsdauer',
  'profile.creditStatus': 'Kreditstatus',
  'profile.increaseCredit': 'Guthaben erhöhen',
  'profile.editCredit': 'Guthaben bearbeiten',
  'profile.employeeCredit': 'Mitarbeiterkredit',
  'profile.creditBalance': 'Guthaben',
  'profile.aboutme': 'Über mich',
  'profile.myfavouritecity': 'Meine Lieblingsstädte',
  'profile.startTravelDate': 'Reisedatum von',
  'profile.endTravelDate': 'Datum der Reise nach',
  'profile.loan': 'Darlehen',
  'profile.gift': 'Geschenk',
  'profile.messageType': 'Nachrichtentyp',
  'profil.text': 'Text',
  'profile.file': 'Datei',
  'profile.totalPurchaseAmount': 'Gesamtkaufbetrag',
  'profile.topCustomers': 'Top-Kunden',
  'profile.homeAppliancesSeller': 'Hausgeräteverkäufer',
  'profile.pointsInventory': 'Punkteinventar',
  'profile.pointCard': 'Punktekarte',
  'profile.shoppingList': 'Einkaufsliste',
  'profile.customerInformation': 'Kundeninformationen',
  'profile.customerRegistrationDate': 'Kundenregistrierungsdatum',
  'profile.customerShoppingList': 'Kunden-Einkaufsliste',
  'profile.incomeFromTheCustomer': 'Einkommen vom Kunden',
  'profile.companyAddress': 'Firmenadresse',
  'profile.nameOfCEO': 'Name des CEO',
  'profile.registration/priceChange': 'Registrierung / Preisänderung',
  'profile.printPassengerInvoice': 'Passagierrechnung drucken',
  'profile.registrationPaymentReceipts': 'Registrierung von Zahlungseingängen',
  'profile.priceToBuyFromOwner': 'Preis beim Tripsi zu kaufen',
  'profile.salesPriceCustomer': 'Verkaufspreis an den Kunden',
  'profile.salesManager': 'Vertriebsleiter',
  'profile.showLess': 'Weniger anzeigen',
  'profile.purchaseRate': 'Einkaufsrate',
  'profile.changeTicketSalesRates': 'Ticketverkaufspreise ändern',
  'profile.savePrice': 'Preis speichern',
  'profile.remainingAmount': 'Restbetrag',
  'profile.firstPayment': 'Erste Zahlung',
  'profile.settlementOfTickets': 'Abrechnung von Tickets',
  'profile.totalAmount': 'Gesamtbetrag',
  'profile.attachedPaymentReceipt': 'Zahlungsbeleg angehängt',
  'profile.attachedPaymentReceipt1': 'Erste beigefügte Quittung',
  'profile.attachedPaymentReceipt2': 'Zweite beigefügte Quittung',
  'profile.attachedPaymentReceipt3': 'Dritte beigefügte Quittung',
  'profile.attachedPaymentReceipt4': 'Vierte beigefügte Quittung',
  'profile.attachedPaymentReceipt5': 'Fünfte beigefügte Quittung',
  'profile.totalRemaining': 'Verbleibende Summe',
  'profile.saveAndNextReceipt': 'Speichern und nächste Quittung',
  'profile.saveAndExit': 'Speichern und beenden',
  'profile.travel': 'Reisen',
  'profile.editconfirmation':
    'Durch das Einreichen einer Bearbeitungsanfrage wird Ihr Profil gesperrt, bis es von Tripsi genehmigt wird. Sind Sie einverstanden?',
  'profile.searchtobuy': 'Suche-zu-Kauf-Verhältnis',
  'profile.me': 'Tell about yourself.Get points',
  'profile.listOfPassengers': 'Liste der Passagiere',
  'profile.customer': 'Kunde',
  'profile.addcity': 'Stadt hinzufügen',
  'profile.showinfo': 'Informationen anzeigen',
  'profile.editPassengerInformation': 'Passagierinformationen bearbeiten',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'Ihr Passagier wurde erfolgreich registriert',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'Die angeforderten Passagierinformationen wurden erfolgreich bearbeitet',
  'profile.customerSuccessfullyRegistered': 'Kunde erfolgreich registriert',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'Die gewünschten Kundeninformationen wurden erfolgreich bearbeitet',
  'profile.addfriend': 'Freund hinzufügen',
  'profile.inveitefriend': 'Freunde einladen',
  'profile.editEmployeeSuccessfully': 'Mitarbeiter erfolgreich bearbeiten',
  'profile.updateEmployeeSuccess':
    'Die Mitarbeiterinformationen wurden erfolgreich bearbeitet',
  'profile.mostSales': 'Die meisten Verkäufe',
  'profile.theLowestNumberOfSales': 'Niedrigster Umsatz',
  'profile.mostSalesAmount': 'Höchster Verkaufsbetrag',
  'profile.theLowestSalesAmount': 'Der niedrigste Verkaufsbetrag',
  'profile.mostActivityTime': 'Zeit mit den meisten Aktivitäten',
  'profile.minimumActivityTime': 'Mindestaktivitätszeit',
  'profile.employeeActivities': 'Mitarbeiteraktivitäten',
  'profile.applyChanges': 'Änderungen übernehmen',
  'profile.planPassenger': 'Passagier planen',
  'profile.all': 'alle',
  'profile.Activities': 'Aktivitäten',
  'profile.allProfiles': 'Profile',
  'profile.allStatuses': 'Status',
  'profile.dragtoadd': 'Zum Hinzufügen ziehen',
  'profile.dragtotransfer': 'Zum Übertragen ziehen',
  'profile.alltransactions': 'Alle Transaktionen',
  'profile.changedate': 'Datum ändern',
  'profile.allusers': 'Alle Nutzer',
  'profile.recentTravels': 'Letzte Reisen',
  'profile.mounthReport': 'Leistungsbericht des letzten Monats',
  'profile.recentNews': 'Neueste Nachrichten',
  'profile.tourismNews': 'Tourismus Nachrichten',
  'profile.recentMonthActivitie': 'Aktivitäten des letzten Monats',
  'profile.donutChart': 'Reisen gemacht',
  'profile.NumberFlightPurchases': 'Anzahl der Flugkäufe',
  'profile.NumberFlightSearches': 'Anzahl der Flugsuchen',
  'profile.profileedit': 'Profil bearbeiten',
  'profile.text': 'Text',
  'profile.agree': 'Zustimmen',
  'profile.changeLogo': 'Logo ändern',
  'profile.editingInformation': 'Bearbeiten von Info',
  'profile.webSite': 'Webseite',
  'profile.presensnt': 'Gegenwärtig',
  'profile.absence': 'Abwesend',
  'profile.leave': 'Verlassen',
  'profile.inviteEmployees': 'Mitarbeiter einladen',
  'profile.textEmployees':
    'Über das unten stehende Formular können Sie Einladungen an Mitarbeiter senden, die das Unternehmen verlassen haben und über aktive Benutzernamen verfügen, und sie Ihrer Sammlung hinzufügen .',
  'profile.addEmployees': 'Mitarbeiter hinzufügen',
  'profile.textAddemplo':
    'Über das unten stehende Formular können Sie dem Unternehmen neue Mitarbeiter hinzufügen und ihre Leistung durch verschiedene Funktionen des Systems überwachen .',
  'profile.copy': 'kopiert',
  'profile.editEmployeeInformation': 'Mitarbeiterdaten bearbeiten',
  'profile.purchases': 'Einkäufe',
  'profile.addCustomer': 'Kunde hinzufügen',
  'profile.textCustomer':
    'Über das folgende Formular können Sie Ihre gewünschten Kunden zur Sammlung hinzufügen, indem Sie die folgenden Informationen ausfüllen.',

  'profile.customerList': 'Kundenliste',
  'profile.services': 'Unsere Leistungen',
  'profile.tourManagement': 'Tour Management',
  'profile.onlineFriend': 'meine Online-Freunde',
  'profile.Invite': 'Einladen',
  'profile.add': 'hinzufügen',
  'profile.passengers': 'Passagiere',
  'profile.messages': 'Mitteilungen',
  'profile.Services': 'Dienstleistungen',
  'profile.messageNo': 'Nachrichtennummer',
  'profile.flight': 'Flug',
  'profile.paid': 'Bezahlt',
  'profile.unpaid': 'Unbezahlt',
  'profile.choosefile': 'Datei auswählen',
  'profile.sellername': `Name des Verkäufers`,
  'profile.factoreno': 'Faktor Nr',
  'profile.customername': 'Kundenname',
  'profile.phonenumber': 'Handynummer',
  'profile.printinvoice': 'Rechnung drucken',
  'profile.signature': 'Buchhaltungsstempel und Unterschrift',
  'profile.signaturetext':
    'Ohne Siegel und Unterschrift ist die Buchhaltung ungültig.',
  'profile.servicedescription': 'Leistungsbeschreibung',
  'profile.taxesduties': 'Steuern und Zölle',
  'profile.purchaseamount': 'Gesamtbetrag des Einkaufs',
  'profile.friendsearch': 'Name, Nationalcode, Reisepass-Nr',
  'profile.ticketsearch': 'Titel, Ticket-Nr',
  'profile.messagesearch': 'Betreff, Nachrichtennr',
  'profile.bookingflightsearch': 'Name, Bestellnr',
  'profile.transactionsearch': 'Name, Bestellnr',
  'profile.employeesearch': 'Name, E-Mail',
  'profile.customersearch': 'Kundenname',
  'profile.passangersearch': 'Name, Nationalcode, Reisepass-Nr',
  'profile.activities': 'Aktivitäten',
  'profile.addlicenselink': 'Lizenz hinzufügen',
  'profile.startnewsevent': 'Veranstaltung starten',
  'profile.endnewsevent': 'Endereignis',
  'profile.descriptionnews': 'Nachrichtentext : ',
  'profile.introduction': 'Einführung',
  'profile.firsttravel': 'Warten auf die erste Reise...',
  'profile.transactionnumber': 'Transaktionscode : ',
  'profile.notfoundnews': 'Nicht gefundene Nachrichten',
  'profile.notfoundtravel': `Du bist noch nicht gereist.`,
  'profile.waitingTrip': 'Wir warten auf Ihre erste Reise...',
  'profile.addLicenseText':
    'Über das Formular unten können Sie am Ende Ihre Berechtigungen und Registrierungsinformationen eingeben.',
  'profile.simpleuser': 'Normaler Benutzer',
  'profile.owner': 'Eigentümer',
  'profile.crm': 'CRM',
  'profile.counter': 'Schalter',
  'profile.accountants': 'Buchhalter',
  'profile.roles': 'Rollen',
  'profile.submitchangerate': 'Änderung der Verkaufsrate war erfolgreich',
  'profile.paymentprice': 'Zahlungspreis',
  'profile.savesuccessfully': 'Profil erfolgreich gespeichert',
  'profile.viewfile': 'Datei anzeigen',
  'profile.backgammon': 'Schachbrettspiel',
  'profile.chatgpt': 'Chat GPT',
  'profile.calendar': 'Kalender',
  'profile.game': 'Spiel',
  'profile.addgateway': 'Flugstrecke hinzufügen',
  'profile.editgateway': 'Flugstrecke bearbeiten',
  'profile.addgatewaydescription':
    'In diesem Formular können Sie die gewünschte Flugstrecke eintragen. Nach dem Eintrag werden die Suchanfragen gemäß den eingetragenen Flugstrecken durchgeführt',
  'profile.editgatewaydescription':
    'In diesem Formular können Sie die gewünschte Flugstrecke bearbeiten. Nach der Bearbeitung werden die Suchanfragen gemäß den eingetragenen Flugstrecken durchgeführt',
  'profile.gatewayroutes': 'Flugstrecken',
  'profile.airlinecode': 'Airline-Code',
  'profile.internalcode': 'Interner Code',
  'profile.weekdays': 'Wochentage',
  'profile.known': 'Bekannt',
  'profile.unknown': 'Unbekannt',
  'profile.airlinestatus': 'Status der Airline',
  'profile.allroutes': 'Alle Strecken',
  'profile.selectoriginanddestination': 'Ursprung und Ziel wählen',
  'profile.siti': 'Siti',
  'profile.sito': 'Sito',
  'profile.soti': 'Soti',
  'profile.soto': 'Soto',
  'profile.pathchoice': 'Streckenwahl',
  'profile.submiteditgateway': 'Bearbeitung der Strecke bestätigen',
  'profile.submitaddgateway': 'Hinzufügen der Strecke bestätigen',
  'profile.selectflightsdays': 'Flugtage auswählen',
  'profile.departureflightcity': 'Abflugstadt',
  'profile.arrivalflightcity': 'Ankunftsstadt',
  'profile.ascinternalcode': 'Aufsteigende Reihenfolge des internen Codes',
  'profile.descinternalcode': 'Absteigende Reihenfolge des internen Codes',
  'profile.ascairlinecode': 'Aufsteigende Reihenfolge des Airline-Codes',
  'profile.descairlinecode': 'Absteigende Reihenfolge des Airline-Codes',
  'profile.addgatewaysuccessfully': 'Flugstrecke erfolgreich hinzugefügt',
  'profile.editgatewaysuccessfully': 'Flugstrecke erfolgreich bearbeitet',
  'profile.notallowed':
    'Profil kann nicht vor der Genehmigung ausgewählt werden',
  'profile.addcustomerduplicated':
    'Der gewünschte Kunde ist bereits registriert',
  'profile.loading': 'Laden...',
  'profile.textAddfriend':
    'Sie können Ihren Freunden über das folgende Formular eine Einladung senden und sie zu Ihrer Freundesliste hinzufügen.',
  'profile.reservations': 'Reservierungen',
  'profile.clubCard': 'Club Karte',
  'profile.Invoices': 'Rechnungen',
  'profile.textEditingTripsi':
    'Sie können Ihre Profilinformationen über das untenstehende Formular ändern. Beachten Sie jedoch, dass das Profil nach der Änderung zunächst auf die Genehmigung durch Tripsi wartet.',
  'profile.textEditingTripord':
    'Sie können Ihre Profilinformationen über das untenstehende Formular ändern. Beachten Sie jedoch, dass das Profil nach der Änderung zunächst auf die Genehmigung durch Tripord wartet.',
  'profile.textPassword':
    'Sie können Ihr Passwort ändern und über das untenstehende Formular ein neues Passwort festlegen.',
  'profile.textDepartment':
    'Über das untenstehende Formular können Sie sich bei der gewünschten Abteilung anmelden bzw. erneut ansprechen.',
  'profile.transferType': 'Übertragungstyp',
  'profile.transferamount': 'Überweisungsbetrag',
  'profile.transaction': 'Transaktionen',
  'profile.sendfile': 'Bankbeleg senden',
  'profile.sendfiles': 'Bankbelege senden',
  'profile.factorestartdate': 'Rechnungsanfangsdatum',
  'profile.factoreenddate': 'Rechnungsendedatum',
  'profile.factoredate': 'Rechnungsdatum',
  'profile.allfactors': 'Alle Rechnungen',
  'profile.walletnotenough': 'Das Wallet-Guthaben ist nicht ausreichend',
  'profile.approvePrice': 'Genehmigter Preis',
  'profile.oldsecondpassword': 'Altes zweites Passwort',
  'profile.setSecondPasswordInfo':
    'Wenn Sie das zweite Passwort zum ersten Mal festlegen, müssen Sie dieses Feld nicht eingeben.',
};
